import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { ComponentModule } from '~/component/component.module';
import { CoreModule } from '~/core/core.module';
import { LEAVE_MODAL_CONFIG } from '~/organizer/shared/components/shared/layouts/funnel/funnel.component';
import { NAVIGATION_ROUTING } from '~/organizer/shared/components/shared/navigation-buttons/navigation-buttons.component';
import { STEPPER_TAB_BAR_CONFIG } from '~/organizer/shared/components/shared/page-container/page-container.component';
import { OrganizerSharedModule } from '~/organizer/shared/shared.module';
import { ParamethorModule } from '~/paramethor/paramethor.module';

import { OrganizerActivityCreationRoutingModule } from './activity-creation-routing.module';
import { OrganizerActivityCreationPageAddressComponent } from './components/pages/address/address.component';
import { OrganizerActivityCreationPageAudienceComponent } from './components/pages/audience/audience.component';
import { OrganizerActivityCreationPageSportBirthdayOfferComponent } from './components/pages/birthday-sport-offer/birthday-sport-offer.component';
import { OrganizerActivityCreationPageDescriptionComponent } from './components/pages/description/description.component';
import { OrganizerActivityCreationPageDurationComponent } from './components/pages/duration/duration.component';
import { OrganizerActivityCreationPageEquipmentComponent } from './components/pages/equipment/equipment.component';
import { OrganizerActivityCreationPageGroupSizeComponent } from './components/pages/group-size/group-size.component';
import { OrganizerActivityCreationPagePhotosComponent } from './components/pages/photos/photos.component';
import { OrganizerActivityCreationPagePlansComponent } from './components/pages/plans/plans.component';
import { OrganizerActivityCreationPagePreviewComponent } from './components/pages/preview/preview.component';
import { OrganizerActivityCreationPageReservationParametersComponent } from './components/pages/reservation-parameters/reservation-parameters.component';
import { OrganizerActivityCreationPageSportComponent } from './components/pages/sport/sport.component';
import { OrganizerActivityCreationPageTitleComponent } from './components/pages/title/title.component';
import { OrganizerActivityCreationPageTypeComponent } from './components/pages/type/type.component';
import { OrganizerActivityCreationPageUploadsComponent } from './components/pages/uploads/uploads.component';
import { OrganizerActivityCreationPageUrlComponent } from './components/pages/url/url.component';
import { organizerActivityCreationLeaveModalConfig } from './configs/leave-modal.config';
import { organizerActivityCreationRoutingConfig } from './configs/routing.config';
import { organizerActivityCreationStepperTabBarConfig } from './configs/stepper.config';

@NgModule({
  imports: [
    OrganizerActivityCreationRoutingModule,
    CommonModule,
    ComponentModule,
    OrganizerSharedModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ParamethorModule,
  ],
  providers: [
    {
      provide: LEAVE_MODAL_CONFIG,
      useValue: organizerActivityCreationLeaveModalConfig,
    },
    {
      provide: NAVIGATION_ROUTING,
      useValue: organizerActivityCreationRoutingConfig,
    },
    {
      provide: STEPPER_TAB_BAR_CONFIG,
      useValue: organizerActivityCreationStepperTabBarConfig,
    },
  ],
  declarations: [
    OrganizerActivityCreationPageAddressComponent,
    OrganizerActivityCreationPageAudienceComponent,
    OrganizerActivityCreationPageDescriptionComponent,
    OrganizerActivityCreationPageDurationComponent,
    OrganizerActivityCreationPageEquipmentComponent,
    OrganizerActivityCreationPageGroupSizeComponent,
    OrganizerActivityCreationPagePhotosComponent,
    OrganizerActivityCreationPagePreviewComponent,
    OrganizerActivityCreationPageReservationParametersComponent,
    OrganizerActivityCreationPageSportComponent,
    OrganizerActivityCreationPageTitleComponent,
    OrganizerActivityCreationPageTypeComponent,
    OrganizerActivityCreationPageUrlComponent,
    OrganizerActivityCreationPagePlansComponent,
    OrganizerActivityCreationPageUploadsComponent,
    OrganizerActivityCreationPageSportBirthdayOfferComponent,
  ],
})
export class OrganizerActivityCreationModule {}
